import { render, staticRenderFns } from "./AfterSubmit.vue?vue&type=template&id=60b4ed00&scoped=true&"
import script from "./AfterSubmit.vue?vue&type=script&lang=ts&"
export * from "./AfterSubmit.vue?vue&type=script&lang=ts&"
import style0 from "./AfterSubmit.vue?vue&type=style&index=0&id=60b4ed00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b4ed00",
  null
  
)

export default component.exports